import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ActivitiesHttpResult,
  SessionActivitiesResult,
} from '../../models/activity.model';
import { StatSportType } from '../../models/stats.model';
import { ActivityApi } from '../activity.api';

@Injectable({
  providedIn: 'root',
  useClass: ActivityApi,
})
export abstract class IActivityApi {
  abstract getActivities(
    page: number,
    limit: number,
    userId?: number
  ): Observable<ActivitiesHttpResult>;

  abstract getActivitiesByMonth(
    month: number,
    year: number,
    sportType: StatSportType,
    limit?: number,
    page?: number,
    userId?: number
  ): Observable<SessionActivitiesResult>;
}
